import * as React from 'react';
import { isNil } from 'ramda';
import { plural } from '@cian/utils';
import { IRailwayDirection } from '../../../types/geo';
import { IRailwaySuggest } from '../../../store/stations';
import { RailwayIcon } from '../../icons';
import { ListGroup, ListItem } from './ListGroup';
import { getSuggestLinkText } from './getSuggestLinkText';
import * as styles from './index.css';

const VARIANTS_OF_DIRECTION: [string, string, string] = ['Направление ', 'Направления ', 'Направления'];

interface IStationsSuggestionsProps {
  textValue: string;
  directions: IRailwayDirection[];
  suggests: IRailwaySuggest[];
  handleItemSelect(suggest: IRailwaySuggest): void;
}

export const StationsSuggestions: React.FC<IStationsSuggestionsProps> = props => {
  const { textValue, directions, suggests, handleItemSelect } = props;

  const directionsNames: { [key: number]: string[] } = directions.reduce((names, current) => {
    const { id, name } = current;

    return !isNil(id)
      ? {
          ...names,
          id: name,
        }
      : { ...names };
  }, {});

  return (
    <ListGroup title="Ж/Д станции" icon={<RailwayIcon />}>
      {suggests.map(suggest => (
        <ListItem key={`suggestion-${suggest.id}`} onClick={() => handleItemSelect(suggest)}>
          <span>{getSuggestLinkText(suggest.name, textValue, suggest.alternativeNames)}</span>
          {suggest.directions && suggest.directions.length > 0 && (
            <div className={styles['list-item_description']}>
              {plural(suggest.directions.length, VARIANTS_OF_DIRECTION)}
              {suggest.directions
                .map(dir => directionsNames[dir])
                .filter(Boolean)
                .join(', ')}
            </div>
          )}
        </ListItem>
      ))}
    </ListGroup>
  );
};
